import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getSafeGateway } from '@tectonics/prs/core/gateway';

export function getGatewayUssdCode(incomingPayment: PendingIncomingPayment): string | null | undefined {
  const gateway = getSafeGateway(incomingPayment);
  return gateway['ussd_code'];
}

export function getSafeGatewayUssdCode(incomingPayment: PendingIncomingPayment): string {
  const code = getGatewayUssdCode(incomingPayment);

  if (!code) {
    throw new Error('getSafeGatewayUssdCode - there is no ussd code in the incoming payment');
  }

  return code;
}
